import { render, staticRenderFns } from "./OnboardingWizard.vue?vue&type=template&id=0714fc4f&scoped=true&"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizard.vue?vue&type=style&index=0&id=0714fc4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714fc4f",
  null
  
)

export default component.exports